var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"showImg",on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.isError)?_c('img',{staticStyle:{"max-height":"50px","max-width":"100%"},attrs:{"src":_vm.url},on:{"error":_vm.resourcesError}}):_c('img',{staticClass:"error-img",staticStyle:{"height":"50px"},attrs:{"src":require("@/assets/img/error.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }